module.exports = __webpack_public_path__ + "img/QUEL_resolution_V2_top_sm.740cb175.webp";